module.exports = __webpack_public_path__ + "img/refuel_bigblvd.gm.134c07c.png";